export default __webpack_public_path__ + "static/media/6.ae2d5169.svg";